import React from 'react'
import { ReactSelect } from '@softura/customcomponent'
import './SearchSelectbox.scss'

interface IProps {
  placeholder?: string,
  options?: any,
  onChange?: any,
  name?:any,
  value?: any,
  filterOptionValue?: any;
  className?: any;
  isSearchable?:boolean;
  defaultValue?: any,
  menuIsOpen?:any
  selectRef?:any,
  autoFocus?:boolean,
  isDisabled?: boolean,
  filterOption?:Function,
  blurInputOnSelect?:any,
  inputmode?:any,
  inputValue?: any,
  onInputChange?:any,
  onBlur?:any,
  menuShouldScrollIntoView?:any
  isLoading?: any,
  noOptionsMessage?: any,
  isClearable?: any,
  'data-attribute'?: any,
}

const SearchSelectBox = ({
  placeholder = 'Select',
  options,
  onChange,
  name,
  value,
  filterOptionValue=1 ,
  className="",
  isSearchable=false,
  defaultValue,
  selectRef,
  autoFocus,
  menuIsOpen,
  isDisabled,
  filterOption,
  blurInputOnSelect,
  inputmode,
  inputValue,
  onInputChange,
  onBlur,
  menuShouldScrollIntoView,
  isLoading,
  noOptionsMessage,
  isClearable,
  'data-attribute': dataAttribute
}:IProps) => {

const colourStyles:any = {
  control: (baseStyles:any, state:any) => ({
    ...baseStyles,
    borderColor: state.isFocused ? 'grey !important' : '#B7DEFF !important',
  }),

  option: (styles:any, { data, isDisabled, isFocused, isSelected }:any) => {
    return {
      ...styles,
      backgroundColor: isSelected
        ? '#8BC400'
        : '',
      borderBottom: '1px solid #8BC400'
    }
  }
}
  return (
    <ReactSelect
      placeholder={placeholder}
      options={options}
      filterOptionValue={filterOptionValue}
      onChange={onChange}
      value={value}
      name={name}
      styles={colourStyles}
      className={`search-dropdown ${className}`} 
      isSearchable={isSearchable}
      defaultValue = {defaultValue}
      selectRef={selectRef}
      menuIsOpen = {menuIsOpen}
      isDisabled = {isDisabled}
      filterOption = {filterOption}
      blurInputOnSelect={blurInputOnSelect}
      inputmode={inputmode}
      inputValue={inputValue}
      onInputChange={onInputChange}
      onBlur={onBlur}
      menuShouldScrollIntoView={menuShouldScrollIntoView}
      isLoading = {isLoading}
      noOptionsMessage = {noOptionsMessage}
      isClearable = {isClearable}
      id = {dataAttribute}
    />
  )
}

export default SearchSelectBox;
